import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { IAnyObject } from '../../services/error/error.handler';
import { OirDialogButton, OirDialogSize } from './oir-dialog.types';

@Component({
  selector: 'oir-mat-dialog',
  templateUrl: './oir-dialog.component.html',
  styleUrls: ['./oir-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OirDialogComponent implements AfterViewInit {
  public onConfirm: () => Observable<any>;
  public onCancel: () => Observable<any>;
  public OirDialogSize = OirDialogSize;

  @ViewChild('defaultTemplate', { static: true })
  public defaultTemplate: TemplateRef<any>;

  @ViewChild('outlet', { read: ViewContainerRef, static: true })
  public outlet: ViewContainerRef;

  @Input()
  public cancelButton: OirDialogButton | string;
  @Input()
  public confirmButton: OirDialogButton | string;
  @Input()
  public title: string;
  @Input()
  public message: string;
  @Input()
  public messageParams: IAnyObject;
  @Input()
  public template: TemplateRef<any>;
  @Input()
  public context: IAnyObject;
  @Input()
  public size: OirDialogSize = OirDialogSize.DEFAULT;
  @Input()
  public scrollable = false;
  @Input()
  public translate = true;

  @Output()
  public readonly confirm: EventEmitter<boolean> = new EventEmitter();

  constructor(private cd: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    this.outlet.createEmbeddedView(
      this.template ? this.template : this.defaultTemplate,
      this.context
    );
    this.cd.detectChanges();
    if (this.outlet.element.nativeElement.parentElement.clientHeight > 500) {
      this.scrollable = true;
    }
    this.cd.detectChanges();
  }

  public doConfirm(): void {
    if (this.onConfirm) {
      this.onConfirm().pipe(take(1)).subscribe();
    }
    this.confirm.emit(true);
  }

  public doCancel(): void {
    if (this.onCancel) {
      this.onCancel().pipe(take(1)).subscribe();
    }
    this.confirm.emit(false);
  }
}
